/**
 * 学习乐园 · 排排序题材包：字母表（paixu/pack-zimu.js）
 * ---------------------------------------------------------------------------
 * 26 个大写字母按字母表顺序排——「ABC 歌」唱的就是这个序。字母全集
 * 太大不逐局全排：每局随机抽 18 张（9×2），多玩几局凑齐整个字母表。
 * note 只给三个有「位置意义」的锚点（A 开头、M 正中间、Z 收尾），其余
 * 留空——字母表本身没有逐个讲的故事，硬配 26 条说明是凑数。
 */
(function (global) {
  'use strict';
  var PACKS = global.STPX_PACKS = global.STPX_PACKS || {};

  var letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  var notes = { A: '字母表第一个', M: '第 13 个，正好在中间', Z: '最后一个' };
  var items = [];
  for (var i = 0; i < letters.length; i++) {
    items.push({ face: letters[i], note: notes[letters[i]] || '' });
  }

  PACKS.zimu = {
    id: 'zimu',
    name: '字母表',
    hint: '每局抽 18 个排回 A 到 Z',
    cols: 9,
    draw: 18,
    winText: 'A B C D E F G……用《字母歌》的调子唱一遍，就是刚才排的顺序。',
    items: items
  };
})(typeof window !== 'undefined' ? window : globalThis);
